import React from 'react';
import AliceCarousel from 'react-alice-carousel';
import "react-alice-carousel/lib/alice-carousel.css";

const Carusel = (props) => {
    const _responsive = {
        0: { items: 1 },
        600: { items: 2 },
        1024: { items: 3 },
    };

    return (

        <AliceCarousel
            duration={400}
            autoPlay={true}
            startIndex={1}
            fadeOutAnimation={true}
            mouseDragEnabled={true}
            autoPlayInterval={500}
            autoPlayDirection="rtl"
            responsive={_responsive}
            style={{
                height: "200px"
            }}
        >
            {props.imgs.map((_prop, key) => {
                var img = new Image();
                img.src = `_prop`;
                return (<img key={key} className="d-block z-depth-5"
                    src={_prop}
                    alt=""
                    style={{
                        objectFit: "scale-down",
                        objectPosition: "top",
                        display: "block",
                        height: "200px",
                        width: "400px"
                    }}
                />);

            })
            }

        </AliceCarousel>
    )
}

export default Carusel;


// WEBPACK FOOTER //
// ./src/components/Carusel/Carusel.jsx